import { Pagination } from '../models/Pagination';
import React from 'react';

export const PaginationSummary: React.FC<{
  pagination: Pagination;
}> = props => {
  return (
    <div>
      <small>
        Showing {props.pagination.pageLowerIndex} - {props.pagination.pageUpperIndex} of {props.pagination.totalCount}{' '}
        Results
      </small>
    </div>
  );
};

export const PaginationNavigation: React.FC<{
  pagination: Pagination;
  onPageChange: any;
}> = props => {
  return (
    <nav>
      <div className="text-center" role="navigation" aria-label="Pagination Navigation">
        <ul className="pagination">
          <li className={'page-item ' + (props.pagination.currentPage === 0 ? 'disabled' : '')}>
            <button
              className="page-link"
              disabled={props.pagination.currentPage === 0}
              onClick={e => {
                e.preventDefault();
                props.onPageChange(0);
              }}
            >
              First
            </button>
          </li>
          {[...Array(props.pagination.numberOfPagesToShow)].map((e, i) => {
            const pageToShow = props.pagination.firstPageToShow + i;
            return (
              pageToShow <= props.pagination.lastPageToShow && (
                <li
                  key={`pageItem${pageToShow}`}
                  className={'page-item' + (props.pagination.currentPage === pageToShow ? ' active' : '')}
                >
                  <button
                    className="page-link"
                    disabled={props.pagination.currentPage === pageToShow}
                    onClick={e => {
                      e.preventDefault();
                      props.onPageChange(pageToShow);
                    }}
                  >
                    {pageToShow + 1}
                  </button>
                </li>
              )
            );
          })}
          <li className={'page-item ' + (props.pagination.currentPage >= props.pagination.maxPage ? 'disabled' : '')}>
            <button
              className="page-link"
              disabled={props.pagination.currentPage >= props.pagination.maxPage}
              onClick={e => {
                e.preventDefault();
                props.onPageChange(props.pagination.maxPage);
              }}
            >
              Last
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
};
